A suggested action the user can take to resolve the issue.

Currently only two codes are defined: "ContactSeek" and "ManagePosition".

This will be null if no call to action is applicable.
